module.exports = __webpack_public_path__ + "img/ypo-renewals-stage-1.caaa3b8f.png";